import { Component, h, Host, Prop } from '@stencil/core';
import { t } from '../../i18n';

@Component({
  tag: 'sy-skeleton',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class Skeleton {
  private items: number[] = [];

  /**
   * Number of skeleton children to render in component
   */
  @Prop() count = 1;

  /**
   * Animation type
   */
  @Prop() animation: 'shimmer' | 'pulse' | 'none' = 'shimmer';

  /**
   * Direction to render skeleton children in component
   */
  @Prop() direction: 'row' | 'column' = 'column';

  /**
   * Custom aria-label for the skeleton
   */
  @Prop({ reflect: true }) accessibleLabel: string;

  /**
   * Custom aria-valuetext for the skeleton
   */
  @Prop({ reflect: true }) accessibleValueText: string;

  componentWillRender() {
    this.items = new Array(this.count);
    this.items.fill(1);
  }

  render() {
    return (
      <Host style={{ '--sy-skeleton-direction': this.direction }}>
        {this.items.map((_, index) => {
          return (
            <span
              key={index}
              style={{
                [this.direction === 'row' ? '--sy-skeleton-count-width' : '--sy-skeleton-count-height']: String(
                  this.count,
                ),
              }}
              class={{
                [this.animation]: true,
              }}
              aria-busy="true"
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuetext={this.accessibleValueText ?? t('LOADING', 'loading')}
              aria-label={this.accessibleLabel ?? t('LOADING', 'loading')}
              role="progressbar"
            ></span>
          );
        })}
      </Host>
    );
  }
}
